var secHeaderJs = (function () {
  //Init Scope variables
  var paramsValue = {},
  queryStringUTM = "",
  whiteListParams = [
    'utm_source',
    'utm_medium',
    'utm_platform',
    'utm_content',
    'utm_campaign',
    'utm_campaigncode',
    'utm_term'
  ],
  paramsObj = window.location.search
  .slice(1)
  .split('&')
  .map(function (p) {
    return p.split('=');
  })
  .reduce(function (obj, pair) {
    if (pair.length >= 2) {
      obj[pair[0]] = pair[1];
    }
    return obj;
  }, {});

  //Read from cookie
  if (Object.keys(paramsObj).length == 0) {
    var cookieUtmParams = Cookie.read(stage_env_cookie_prefix + "user_utm_data");
    if (cookieUtmParams) {
      paramsObj = bsLib.JSONParse(cookieUtmParams);
    }
  }

  // check white list params
  Object.keys(paramsObj).forEach(function (key) {
    if (whiteListParams.indexOf(key) > -1) {
      paramsValue[key] = paramsObj[key];
    }
  });

  function init() {
    /**
    * Check if secondary nav exists then only call this function
    */
    if (document.getElementById("secondary-nav")) {
      uiBindings();
    }
  }
  var uiBindings = function () {
    var secNavMobileDropdown = document.getElementById(
      "features-dropdown-toggle"
    );
    secNavMobileDropdown.addEventListener("click", secNavMobileDropdownFn);
    var secNavMobileDropdownItems = document.getElementById("secondary-nav__features").getElementsByTagName("a");
    for (var i = 0; i < secNavMobileDropdownItems.length; i++) {
      if (!secNavMobileDropdownItems[i].parentElement.classList.contains("custom-nested-secondary-nav")) {
        secNavMobileDropdownItems[i].addEventListener(
          "click",
          secNavMobileDropdownItemsFn
        );
      }

      if (window.innerWidth < 980) {
        secNavMobileDropdownItems[i].addEventListener('keydown', function (event) {
          if (event.key === 'Escape' || event.keyCode === 27) {
            mobileMenuFeature.classList.toggle("dd-toggle");
            mobileMenuDDELem.classList.toggle("active");
            closeAllMenulinksButtons();
            mobileMenuDDELem.focus();
          }
        });
      }
    }
    function secNavMobileDropdownFn(e) {
      e.preventDefault();
      e.stopPropagation();
      mobileMenuFeature.classList.toggle("dd-toggle");
      this.classList.toggle("active");
      closeAllMenulinksButtons();
    }

    function secNavMobileDropdownItemsFn() {
      mobileMenuFeature.classList.toggle("dd-toggle");
      secNavMobileDropdown.classList.toggle("active");
    }

    function closeAllMenulinksButtons() {
      for (var i = 0; i < nestedSecondaryMenuList.length; i++) {
        if (nestedSecondaryMenuList[i].classList.contains("is-toggle")) {
          nestedSecondaryMenuList[i].classList.remove("is-toggle");
          nestedSecondaryMenuList[i].querySelector('a[href="javascript:void(0)"]').classList.remove("is-hover");
          nestedSecondaryMenuList[i].querySelector('a[href="javascript:void(0)"]').setAttribute('aria-expanded', 'false');
          nestedSecondaryMenuList[i].getElementsByTagName("ul")[0].dataset.isopen = 'false';
        }
      }
    }

    /**
    * Nested Secondary sub menu Hover Effects
    */
    var nestedSecondaryMenuList = document.querySelectorAll(".custom-nested-secondary-nav"),
      mobileMenuDDELem = document.getElementById('features-dropdown-toggle'),
      mobileMenuFeature = document.getElementById("secondary-nav__features"),
      noActionMenuItem = document.querySelectorAll(".no-action-menu-item > a"),
      mobileFlag = window.innerWidth > 979,
      secMenuFlag =  eventFlag = mobileFocusFlag = 1;

    // No Action on Menu Items
    for (var i = 0; i < noActionMenuItem.length; i++) {
      noActionMenuItem[i].setAttribute('href', 'javascript:void(0)');
    }

    if (nestedSecondaryMenuList.length) {
      for (var i = 0; i < nestedSecondaryMenuList.length; i++) {
        var nestedSecondaryMenuDD = nestedSecondaryMenuList[i].getElementsByTagName("ul")[0],
          nestedSecondaryMenuItem = nestedSecondaryMenuDD.previousElementSibling,
          nestedSecondaryToggleList = nestedSecondaryMenuDD.getElementsByTagName("li");

        nestedSecondaryMenuList[i].parentNode.classList.add('secondary-nav__nested-menu');
        nestedSecondaryMenuItem.setAttribute('aria-expanded', false);
        nestedSecondaryMenuItem.setAttribute('aria-haspopup', true);
        nestedSecondaryMenuItem.setAttribute('data-target', 'secondary-nested-submenu-' + i);
        nestedSecondaryMenuItem.setAttribute('href', 'javascript:void(0)');

        // prevent default action of anchor
        nestedSecondaryMenuItem.addEventListener("click", function (event) {
          event.preventDefault();
        });

        // set role menuitem to list
        for (var j = 0; j < nestedSecondaryToggleList.length; j++) {
          nestedSecondaryToggleList[j].setAttribute('role', 'menuitem');
        }

        function nestedSecondaryMenuToggleFn() {
          for (var k = 0; k < nestedSecondaryMenuList.length; k++) {
            if (window.innerWidth <= 979) {
              if (secMenuFlag) {
                nestedSecondaryMenuList[k].addEventListener("click", fnToggleSecondaryMenu, false);

                //trap focus in sec nav menu items.
                nestedSecondaryMenuList[k].addEventListener('keydown', function (event) {
                  var that =  this,
                    secMenuDropdownElement = getFirstAndLastFocusableElementOfParent(that),
                    secMenuDropdownFirstFocusElement = secMenuDropdownElement.firstElement,
                    secMenuDropdownLastFocusElement = secMenuDropdownElement.lastElement;
                  if (that.classList.contains('is-toggle')) {
                    trapFocusInElement(event, secMenuDropdownFirstFocusElement, secMenuDropdownLastFocusElement);
                  }
                });

                // focus out last element event
                if (mobileMenuDDELem && mobileFocusFlag) {
                  var mobileMenuItems = document.querySelectorAll(".secondary-nav__features > .secondary-nav__main-menu > li"),
                    lastVisibleMenuItem = null; // Find the last visible menu item that is not hidden
                
                  for (var i = mobileMenuItems.length - 1; i >= 0; i--) {
                    var lastMenuItem = mobileMenuItems[i];
                    if (getComputedStyle(lastMenuItem).display !== 'none') {
                      lastVisibleMenuItem = lastMenuItem;
                      break; // Stop at the first visible item from the end
                    }
                  }
                  
                  if (lastVisibleMenuItem) {
                    lastVisibleMenuItem.addEventListener("focusout", function (event) {
                      if (!lastVisibleMenuItem.classList.contains('is-toggle')) {
                        if (!mobileMenuFeature.classList.contains("dd-toggle")) {
                          mobileMenuFeature.classList.toggle("dd-toggle");
                          mobileMenuDDELem.classList.toggle("active");
                          closeAllMenulinksButtons();
                        }
                      }
                    });
                    mobileFocusFlag = 0;
                  }
                }
                if ((nestedSecondaryMenuList.length - 1) === k) {
                  secMenuFlag = 0;
                }
              }
            } else if (window.innerWidth > 979 && (window.orientation === 90 || window.orientation === -90)) {
              // check landscape mode for ipad to remove event listener on resize
              nestedSecondaryMenuList[k].removeEventListener('click', fnToggleSecondaryMenu, false);
              secMenuFlag = 1;
            }

            if (mobileFlag && eventFlag) {
              nestedSecondaryMenuList[k].addEventListener("focusout", function (event) {
                var that = this;
                nestedSecondaryMenuDD = that.getElementsByTagName("ul")[0];
                nestedSecondaryMenuItem = nestedSecondaryMenuDD.previousElementSibling;
                if (!that.contains(event.relatedTarget)) {
                  if (that.classList.contains("custom-nested-secondary-nav")) {
                    closeSecondaryDD(nestedSecondaryMenuDD, nestedSecondaryMenuItem);
                  }
                }
              });
    
              nestedSecondaryMenuList[k].addEventListener("mouseover", function (event) {
                event.stopPropagation();
                var that = this,
                  rect = that.getBoundingClientRect(),
                  leftPos = rect.left;
                
                nestedSecondaryMenuDD = that.getElementsByTagName("ul")[0];
                nestedSecondaryMenuDD.style.left = leftPos + 'px';
                nestedSecondaryMenuItem = nestedSecondaryMenuDD.previousElementSibling;
                if (window.innerWidth > 979) {
                  if (!that.classList.contains("is-toggle")) {
                    that.classList.add("is-toggle");
                  }
                }
                if (that.classList.contains("custom-nested-secondary-nav")) {
                  nestedSecondaryMenuItem.classList.add("is-hover");
                }
              });
      
              nestedSecondaryMenuList[k].addEventListener("mouseleave", function (event) {
                event.stopPropagation();
                var that = this;
                
                nestedSecondaryMenuDD = that.getElementsByTagName("ul")[0];
                nestedSecondaryMenuItem = nestedSecondaryMenuDD.previousElementSibling;
                if (that.classList.contains("custom-nested-secondary-nav")) {
                  nestedSecondaryMenuItem.classList.remove("is-hover");
                }
                that.classList.remove("is-toggle");
              });

              if ((nestedSecondaryMenuList.length - 1) === k) {
                eventFlag = 0;
              }
            }
          }
        }

        nestedSecondaryMenuToggleFn();

        nestedSecondaryMenuList[i].addEventListener('keydown', function (event) {
          var that = this,
            rect = that.getBoundingClientRect(),
            leftPos = rect.left;
          
          nestedSecondaryMenuDD = that.getElementsByTagName("ul")[0];
          nestedSecondaryMenuDD.style.left = leftPos + 'px';
          nestedSecondaryMenuItem = nestedSecondaryMenuDD.previousElementSibling;

          // on space and enter key press trigger keyboard events
          if (event.keyCode === 32 || event.keyCode === 13 || event.key === 'Enter') {
            if ((event.target.getAttribute('href') !== "#") && (event.target.getAttribute('href') !== "javascript:void(0)")) {
              return true;
            } else if (that.classList.contains("custom-nested-secondary-nav") && event.target.parentElement === that) {
              event.preventDefault();
              openSecondaryDD(nestedSecondaryMenuDD, nestedSecondaryMenuItem);
            }
          }
          if (event.key === 'Escape' || event.keyCode === 27) {
            if (that.classList.contains("custom-nested-secondary-nav")) {
              closeSecondaryDD(nestedSecondaryMenuDD, nestedSecondaryMenuItem);
              nestedSecondaryMenuItem.focus();
            }
          }
        });

        function openSecondaryDD(dropdownElement, buttonElement) {
          var isDropdownOpen = dropdownElement.dataset.isopen;
          if (isDropdownOpen === 'false' || isDropdownOpen === undefined) {
            dropdownElement.dataset.isopen = 'true';
            dropdownElement.parentElement.classList.toggle("is-toggle");
            dropdownElement.previousElementSibling.classList.add('is-hover');
            buttonElement.classList.add('focussed');
            buttonElement.setAttribute('aria-expanded', 'true');
            return true;
          } else {
            closeSecondaryDD(dropdownElement, buttonElement);
          }
        }

        function closeSecondaryDD(dropdownElement, buttonElement) {
          var isDropdownOpen = dropdownElement.dataset.isopen;
          if (!!isDropdownOpen && isDropdownOpen === 'true') {
            dropdownElement.dataset.isopen = 'false';
            dropdownElement.parentElement.classList.remove("is-toggle");
            dropdownElement.previousElementSibling.classList.remove('is-hover');
            buttonElement.classList.remove('focussed');
            buttonElement.setAttribute('aria-expanded', 'false');
            return true;
          }
          return false;
        }

        function fnToggleSecondaryMenu(event) {
          event.stopPropagation();
          var targetElem = event.target.closest('a');
          if (targetElem) {
            if (!((targetElem.getAttribute('href') !== "#") && (targetElem.getAttribute('href') !== "javascript:void(0)"))) {
              var that = this;
              nestedSecondaryMenuDD = that.getElementsByTagName("ul")[0];
              nestedSecondaryMenuItem = nestedSecondaryMenuDD.previousElementSibling;
              that.classList.toggle("is-toggle");
              if (!that.classList.contains("is-toggle")) {
                nestedSecondaryMenuItem.classList.remove('is-hover');
                nestedSecondaryMenuItem.setAttribute('aria-expanded', 'false');
                nestedSecondaryMenuDD.dataset.isopen = 'false';
              } else {
                nestedSecondaryMenuItem.classList.add('is-hover');
                nestedSecondaryMenuItem.setAttribute('aria-expanded', 'true');
                nestedSecondaryMenuDD.dataset.isopen = 'true';
              }
            }
          }
        }

        function trapFocusInElement(event, firstFocusElement, lastFocusElement) {
          if (event.key === 'Tab' || event.keyCode === 9) {
            // tab keycode is 9
            if (event.shiftKey) {
              if (document.activeElement === firstFocusElement) {
                lastFocusElement.focus();
                event.preventDefault();
              }
            } else if (document.activeElement === lastFocusElement) {
              firstFocusElement.focus();
              event.preventDefault();
            }
          }
        }

        function getFirstAndLastFocusableElementOfParent(element) {
          var allFocusableItemsInElement = element.querySelectorAll('.custom-nested-secondary-nav.is-toggle > a, .custom-nested-secondary-nav.is-toggle > ul > li > a, button, input'),
            lengthOfAllFocusableItemsInElement = allFocusableItemsInElement.length;
          return {
            firstElement: allFocusableItemsInElement[0],
            lastElement: allFocusableItemsInElement[lengthOfAllFocusableItemsInElement - 1]
          };
        }

        window.addEventListener('resize', function () {
          nestedSecondaryMenuToggleFn();
          mobileFlag = window.innerWidth > 979;
        }, false);
      }
    }

    /**
    * Nested Secondary Custom single page scroll menu
    */
    var secNavMenuLambdaTest = document.getElementsByClassName("lt_alternative")[0],
      customScrollToSecLinks = document.querySelectorAll('.custom-scrollto-section > a');

    //for Landing page LT vs BS
    if (secNavMenuLambdaTest) {
      var getSignInBtn = document.getElementById('sign_in_link'),
        getCtaBtnMenu = document.getElementById('sec_nav_cta');

      getCtaBtnMenu.classList.add('custom-sec-nav-cta');
      getSignInBtn.innerHTML = "Get Demo";
      getSignInBtn.setAttribute('title', 'Get Demo Sec Header')
    }

    // Custom single page scroll functionality
    if (customScrollToSecLinks.length > 0) {
      for (var i = 0; i < customScrollToSecLinks.length; i++) {
        customScrollToSecLinks[i].addEventListener(
          "click",
          secMenuScrollToSectionFn
        );
      }

      function secMenuScrollToSectionFn(e) {
        e.preventDefault();
        e.stopPropagation();
        removeActiveSectionClass();
        var that = this,
          btn_href = that.getAttribute("href"),
          offsetTop = document.querySelector(btn_href).offsetTop - 60;
        that.classList.add('active-section');
        bsLib.scrollIt(
          offsetTop,
          1000
        );
      }

      function removeActiveSectionClass() {
        for (var i = 0; i < customScrollToSecLinks.length; i++) {
          customScrollToSecLinks[i].classList.remove('active-section');
        }
      }
    }

    /**
    * Double Nested Secondary Custom single page scroll menu
    */
    var customScrollToNestedLinks = document.querySelectorAll('.nested-scrollto-link:not(.nested-dd-menu) > a');

    // Custom single page scroll functionality
    if (customScrollToNestedLinks.length > 0) {
      for (var i = 0; i < customScrollToNestedLinks.length; i++) {
        customScrollToNestedLinks[i].addEventListener(
          "click",
          nestedMenuScrollToSectionFn
        );
      }

      function nestedMenuScrollToSectionFn(e) {
        removeNestedSectionClass();
        var that = this,
          btnHref = that.getAttribute("href"),
          btnScrollId = ((btnHref.indexOf('scroll_to') > -1) ? btnHref.substr(btnHref.indexOf('scroll_to=')) : btnHref),
          btnScrollParams = ((btnScrollId.indexOf('&') > -1) ? btnScrollId.substr(btnScrollId.indexOf('scroll_to='), btnScrollId.indexOf('&')) : btnScrollId.substr(btnScrollId.indexOf('scroll_to='))),
          sectionId = ((btnScrollParams.split('=')[1]) ? (btnScrollParams.split('=')[1]) : btnScrollParams.split('=')[0]),
          promoBarElem = document.getElementsByClassName("promo-notification")[0] ? document.getElementsByClassName("promo-notification")[0].offsetHeight : 0,
          headerElem = document.getElementById("header-habitat") ? document.getElementById("header-habitat").offsetHeight : 0,
          headerHeight = headerElem + promoBarElem,
          offsetElem = document.querySelector('#' + sectionId),
          refSlug = window.location.search;

        if (refSlug.indexOf('?ref=') > -1) {
          refSlug = window.location.search.split('&')[0];
        } else {
          refSlug = '';
        }

        if (offsetElem) {
          e.preventDefault();
          e.stopPropagation();
          var offsetTop = offsetElem.offsetTop - headerHeight,
            url = updateSlugURL(refSlug, true);
          
          that.classList.add('active-nested-link');
          updateQueryStringParameter(url, "scroll_to", sectionId);
          bsLib.scrollIt(
            offsetTop,
            700
          );
        }
      }

      function updateSlugURL(ref_slug, returns) {
        if (history.pushState) { 
          if (Object.keys(paramsValue).length > 0) {
            queryStringUTM = ((ref_slug == '') ? "?" : "&") + Object.keys(paramsValue).map(function(key) {
              return key + '=' + paramsValue[key]
            }).join('&');
          }
          
          var newurl = window.location.pathname + ref_slug + queryStringUTM;
          if (returns) {
            return newurl;
          }
    
          // update referrer
          // https://mattmazur.com/2018/01/25/bookmarklet-to-manually-set-document-referrer/
          var newReferrer = window.location.href;
          Object.defineProperty(document, "referrer", {
            configurable: true,
            get: function() {
              return newReferrer;
            }
          });
          window.history.pushState({ path: newurl }, "", newurl);
        }
      }

      // Function to update Query String in the URL
      // https://jsfiddle.net/bp3tmuxh/1/
      function updateQueryStringParameter(uri, key, value) {
        var re = new RegExp("([?&])" + key + "=.*?(&|#|$)", "i");
        if (value === undefined) {
          if (uri.match(re)) {
            return uri.replace(re, "$1$2");
          } else {
            return uri;
          }
        } else {
          if (uri.match(re)) {
            return uri.replace(re, "$1" + key + "=" + value + "$2");
          } else {
            var hash = "";
            if (uri.indexOf("#") !== -1) {
              hash = uri.replace(/.*#/, "#");
              uri = uri.replace(/#.*/, "");
            }
            var separator = uri.indexOf("?") !== -1 ? "&" : "?";

            //update referrer
            var newReferrer = window.location.href;
            Object.defineProperty(document, "referrer", {
              configurable: true,
              get: function() {
                return newReferrer;
              }
            });

            window.history.pushState(
              { path: window.location.pathname },
              "",
              uri + separator + key + "=" + value + hash
            );
          }
        }
      }
    
      function removeNestedSectionClass() {
        for (var i = 0; i < customScrollToNestedLinks.length; i++) {
          customScrollToNestedLinks[i].classList.remove('active-nested-link');
          customScrollToNestedLinks[i].parentElement.classList.remove('current-menu-item', 'active');
        }
      }
    }
  };
  init();
})();